import $ from 'jquery';
import '../libs/tabslet';

$(document).ready(function () {
  $('.js-tabs').tabslet({
    active: 1,
  });
});
